import { render } from "./dashboard-layout.vue?vue&type=template&id=6ff6cda0"
import script from "./dashboard-layout.vue?vue&type=script&lang=js"
export * from "./dashboard-layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__